export enum AppRolesModel {
  Generic,
  GenericBrowser,
  Personalized,
  PersonalizedBrowser,
}
